import { atom } from 'recoil';

import { firstYear, yearsQuery } from './queries';

export const yearsState = atom({
  key: 'ManagementAnalysisYears',
  default: yearsQuery,
});

export const selectedConversionYearState = atom<string>({
  key: 'ManagementAnalysisSelectedConversionYear',
  default: firstYear,
});

export const selectedFinancialMovementYearState = atom<string>({
  key: 'ManagementAnalysisSelectedFinancialMovementYear',
  default: firstYear,
});

export const selectedInvestmentResumeYearState = atom<string>({
  key: 'ManagementAnalysisSelectedInvestmentResumeYear',
  default: firstYear,
});
